<template>
  <div v-if="contact">
    {{ contact.name }}
    <div>
      {{ contact.address }}
      <span v-if="contact.city && contact.state">, {{ contact.city }}, {{ contact.state }} {{ contact.postcode }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactInfo",
  props: {
    contId: String,
    contacts: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      contact: {}
    }
  },
  created() {
    this.contact = this.contacts.find(c => c.contact_key === this.contId);
  },
}
</script>